









































import { Vue, Component } from 'vue-property-decorator';
import { ImagePreview } from 'vant';
import XGPlayer from '@/components/XGplayer.vue';
import VoteButton from '@/components/next/VoteButton.vue';
import { getDetail } from '../api';
Vue.use(ImagePreview);
@Component({
  components: {
    XGPlayer,
    VoteButton,
  },
})
export default class Detail extends Vue {
  detail: any = {};
  created() {
    this.onGetDetail();
  }
  async onGetDetail() {
    const ret = await getDetail(this.$route.query.id as string);
    this.detail = ret.data;
  }
  onVoteSuccess(res: any) {
    this.detail.votes = Number(this.detail.votes) + 1;
    this.$emit('updateZan');
  }
  onPreviewImage(index: number) {
    ImagePreview({
      images: this.detail.images,
      startPosition: index,
      closeable: true,
    });
  }
}
